import printJS from "print-js";
import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle.ts";
import { downloadFile } from "src/utils/fileDownloading.ts";

export function printFile(fileHandle: FrontendDownloadFileHandle) {
	printJS({
		printable: fileHandle.fileUrl,
		onError: () => {
			downloadFile(fileHandle);
		},
	});
}
